var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPauseOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14277",
    "data-name": "Group 14277",
    transform: "translate(-1251 -108.535)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3733",
    "data-name": "Rectangle 3733",
    width: 4,
    height: 14,
    rx: 1,
    transform: "translate(1251 108.535)",
    fill: "#fa8008"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3734",
    "data-name": "Rectangle 3734",
    width: 4,
    height: 14,
    rx: 1,
    transform: "translate(1259 108.535)",
    fill: "#fa8008"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseOrange);
export default __webpack_public_path__ + "static/media/pauseOrange.f74b60cb5127ded9f0e7a85bcde2dddd.svg";
export { ForwardRef as ReactComponent };